<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <el-descriptions :label-style="{width: '80px'}" :column="1" size="mini" border>
          <el-descriptions-item label="节点ID">
            <el-input :value="id" :disabled="true"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="节点名称">
            <el-input v-model="text"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="上节点">
            <el-input :value="sourceNodeId" :disabled="true"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="下节点">
            <el-input :value="targetNodeId" :disabled="true"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="条件">

            <div class="condition-item" v-for="(item,index) in form.condition">
              <div @click="delTableData" class="condition-item-del">
                <i class="condition-item-del-icon el-icon-circle-close"></i>
              </div>
              <BpmnCondition v-model="form.condition[index]" @success="onInput" />
            </div>
            <div class="footer">
              <el-button size="mini" type="primary" icon="el-icon-circle-plus" circle @click="addCondition"></el-button>
            </div>

          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="抄送">
        <BpmnSelectUser v-model="form.send_copy_user_list" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="监听">
        <BpmnMonitor v-model="form.monitor" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="扩展">
        <BpmnExtend v-model="form.extend" @success="onInput" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BpmnMonitor from "./components/BpmnMonitor";
import BpmnExtend from "./components/BpmnExtend";
import BpmnCondition from "./components/BpmnCondition";
import BpmnSelectUser from "./components/BpmnSelectUser";
import FlowCommon from "../lib/FlowCommon";
export default {
  name: 'PolylineProperty',
  components: {BpmnSelectUser, BpmnCondition, BpmnExtend, BpmnMonitor},
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  mounted() {
    this.onInit()
  },
  data() {
    return {
      id:"",
      text:"",
      sourceNodeId:"",
      targetNodeId:"",
      form: FlowCommon.getNodeDefaultConfig('polyline').properties,
    }
  },
  watch:{
    text(n){
      const nodeData = this.$props.nodeData
      this.$props.lf.updateText(nodeData.id, n);
    }
  },
  methods: {
    onInit(){
      const { properties,text,id,sourceNodeId,targetNodeId } = this.$props.nodeData
      this.id=id;
      this.text=(text||{}).value||"";
      this.sourceNodeId=sourceNodeId;
      this.targetNodeId=targetNodeId;
      if (properties) {
        this.$data.form = Object.assign({}, this.$data.form, properties)
      }
    },
    onInput(){
      var that=this;
      const nodeData = that.$props.nodeData
      nodeData.properties = that.$data.form
      that.$props.lf.setProperties(nodeData.id, that.$data.form);
    },
    addCondition(){
      this.form.condition.push([])
      this.onInput();
    },
    delTableData(index){
      this.form.condition.splice(index,1);
      this.onInput();
    },
    onSubmit() {

    }
  }
}
</script>
<style lang="scss" scoped>
.form-input{
  width: 100%;
}
.condition-item{
  border: 1px solid #e8e8e8;
  margin-top: 10px;
  border-radius: 2px;
  //overflow: hidden;
  position: relative;
}
.condition-item-del{
  position: absolute;
  z-index: 1;
  top: -10px;
  right: -10px;
  cursor: pointer;
  .condition-item-del-icon{
    font-size: 20px;
    color: #ff7e53;
    &:hover{
      font-weight: bold;
      color: #d93a12;
    }
  }
}
.footer{
  margin: 5px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/PolylineProperty.vue